import { connect } from 'react-redux';
import { resetSingleFilter } from '../../store/openOrder';

import FilterIdentifier from './FilterIdentifier';

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  resetSingleFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterIdentifier);
